<template>
  <BaseNoticeItem
    :button-text="$t('Add details')"
    :button-url="buttonUrl"
    status="Information missing"
    data-test="identification-alert"
  >
    <template #head>
      <strong>{{ $t('Missing identification details') }}</strong>
    </template>
    <template #body>
      {{ $t('You must provide personal identification details before you can be hired.') }}
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const { $t } = useTranslation()
const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(
    namedRoutes.frontend.user.profile.edit,
    { redirect_uri: redirectUri },
    false,
  )
  return `${path}#identification-details`
})
</script>
